/* Just Jars product page: match chips on the "same size" row. */
(function(){
  function init(scope){
    (scope||document).querySelectorAll('.mjmjp [data-jp-rel="size"]').forEach(function(sec){
      if(sec.__jp)return; sec.__jp=true;
      var grid=sec.querySelector('[data-jp-grid]'); if(!grid)return;
      var lim=parseInt(sec.getAttribute('data-limit'),10)||4, none=sec.querySelector('[data-jp-none]');
      var cards=[].slice.call(grid.querySelectorAll('.jp-c'));
      function apply(f){
        var pick=cards.filter(function(c){var m=c.dataset.m==='1',s=c.dataset.s==='1';return f==='ms'?(m&&s):f==='m'?m:s});
        if(f==='ms'){pick.sort(function(a,b){return (b.dataset.sh==='1')-(a.dataset.sh==='1')})}
        cards.forEach(function(c){c.hidden=true});
        pick.slice(0,lim).forEach(function(c){c.hidden=false;grid.appendChild(c)});
        if(none)none.hidden=pick.length>0;
      }
      var btns=[].slice.call(sec.querySelectorAll('.jp-chipsel button'));
      btns.forEach(function(b){b.addEventListener('click',function(){btns.forEach(function(x){x.classList.toggle('is-on',x===b)});apply(b.dataset.f)})});
      var start='ms';
      if(!cards.some(function(c){return c.dataset.m==='1'&&c.dataset.s==='1'})){start=cards.some(function(c){return c.dataset.m==='1'})?'m':'s';btns.forEach(function(x){x.classList.toggle('is-on',x.dataset.f===start)})}
      apply(start);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
